<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat>
            <v-icon>card_travel</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;ABM de Grupos Comerciales</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Nombre/Código"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">
                          <tr @click="viewItem(item)">
                            <td class="text-xs-left">{{ item.codigo }}</td>
                            <td class="text-xs-left">{{ item.nombre }}</td>

                            <td class="text-xs-left">                
                              <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                              <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon>
                            </td>
                          </tr>
                      </template>
                    </v-data-table>
                  </v-card >
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>location_city</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">                        
                        <v-icon  medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id>0" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode">
                          <v-layout>
                              <v-flex xs6>
                                  <v-text-field v-model="model.nombre" label="Nombre" required :disabled="!editMode" v-validate="'required'" data-vv-name="nombre" :error-messages="errors.collect('nombre')"></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                  <v-text-field v-model="model.codigo" label="Codigo" required :disabled="!editMode" v-validate="'required'" data-vv-name="codigo" :error-messages="errors.collect('codigo')"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <p v-if="model.id === 0"></p>
                          <p v-else-if="!model.status.baja">Status: Activo</p>
                          <p v-else>Status: Inhabilitado</p>

                          <p>Pertenece A:</p>
                          <app-busqueda-persona propName= "persona" :allowNuevo="true" :alertPersonaInexistente="false" :value="model" :editMode="editMode"></app-busqueda-persona>

                          <v-layout>
                              <v-flex xs6>
                                  <v-text-field v-model="model.telefono" label="Teléfono" :disabled="!editMode"></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                  <v-text-field v-model="model.cbu" label="CBU" :disabled="!editMode" v-validate="'required'" data-vv-name="cbu" :error-messages="errors.collect('cbu')" counter></v-text-field>
                            </v-flex>
                          </v-layout>
                          
                          <v-layout>
                              <v-flex xs6>
                                  <v-text-field v-model="model.email" label="Email" :disabled="!editMode" v-validate="'email'" data-vv-name="email" :error-messages="errors.collect('email')"></v-text-field>
                              </v-flex>
                              <v-flex xs6>
                                  <v-text-field v-model="model.contacto" label="Contacto" :disabled="!editMode"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                              <v-flex xs6>
                                  <v-select :items="periodosLiquidacion" v-model="model.periodoLiquidacion"
                                          item-text="descripcion" item-value="id" label="Periodo Liquidación" 
                                          placeholder="Seleccione uno" 
                                          v-validate="'required'" data-vv-name="periodoLiquidacion" :error-messages="errors.collect('periodo')"
                                          :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-select>
                              </v-flex>
                              <v-flex xs6>
                                  <v-select :items="diasSemana" v-model="model.diaSemana"
                                          item-text="descripcion" item-value="id" label="Día de Liquidación" 
                                          placeholder="Seleccione uno" 
                                          v-validate="'required'" data-vv-name="dia" :error-messages="errors.collect('dia')"
                                          :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-select>
                            </v-flex>
                          </v-layout>

                          <app-domicilio-simple propName= "domicilio" :value="model" :editMode="editMode"></app-domicilio-simple>                          

                          <v-btn color="success" v-if="model.id >0"  @click="verCanalesVenta()">Ver Canales de Venta del Grupo</v-btn>

                          <v-dialog v-model="dialogCanalesVenta" persistent max-width="600px">
                            <app-lista-canalesventa propName= "listaCanalesVenta" :value="listaCanalesVenta" v-on:close-dialog="closeDialog"></app-lista-canalesventa>                          
                          </v-dialog>
                           
                          <v-divider></v-divider>
                          <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions bottom>
                            <v-speed-dial direction="right">
                              <template v-slot:activator>
                                <v-btn color="orange" text small v-show="editMode">
                                  <v-icon color="orange">touch_app</v-icon>                                
                                  Mas Acciones
                                </v-btn>
                              </template>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn small text color="green" v-on="on" @click="copiarDomicilio" v-show="editMode">
                                    Copiar Domicilio
                                  </v-btn>
                                </template>
                                <span>Copia el domicilio de la persona elegida</span>
                              </v-tooltip>
                              <v-btn small text color="green" @click="updateStatus" v-show="editMode" v-if="model.id != 0">
                                  <p v-if="!model.status.baja">Inhabilitar Grupo</p>
                                  <p v-else>Activar Grupo</p>
                              </v-btn>
                              <v-btn small text color="green" @click="agregarCanalVenta" v-show="editMode">
                                Agregar Canal Venta
                              </v-btn>
                              
                            </v-speed-dial>
                             
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>
                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
       
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

const periodosLiquidacion = [
  { id: 1, descripcion: 'Diaria' },
  { id: 2, descripcion: 'Semanal' },
  { id: 3, descripcion: 'Quincenal' },
  { id: 4, descripcion: 'Mensual' },
]

const diasSemana = [
  { id: 1, descripcion: 'Lunes' },
  { id: 2, descripcion: 'Martes' },
  { id: 3, descripcion: 'Miércoles' },
  { id: 4, descripcion: 'Jueves' },
  { id: 5, descripcion: 'Viernes' },
]

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Codigo', value: 'codigo', sortable:false },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      listaCanalesVenta: [],
      dialogCanalesVenta: false,
      model: { status:{} }, // registro para ver/editar,
      periodosLiquidacion: periodosLiquidacion,
      diasSemana: diasSemana
    };
  },
  async created() {     
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    },
    personaBusqueda (value) {
      if(value != null){
        this.model.perteneceAId = value.id;
      }
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete', 'getActionFromLink','personaBusqueda']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {          
        var result = await http.get('gruposcomerciales?nombreOCodigo='+this.search + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false'));

        this.records = result.list;
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true
      this.resetState()
    
      try {
        
        var result = await http.get('gruposComerciales/' +id );
        
        this.model = result;
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {status: {}}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)
      
      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !(this.model.id === 0);
      await this.$validator.validateAll()
      
      if(this.errors.items.length > 0) return;

      if (isUpdate) {
        try{
          await http.put('gruposComerciales', JSON.stringify( {grupoComercial:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }               
      } else {
        try{          
          await http.post('gruposComerciales', JSON.stringify( {grupoComercial:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          Vue.$log.error(error);
          this.alertError(error)
        }         
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación del grupo comercial ' + item.nombre + '?')) {
        try{
            Vue.$log.debug(item);
            await http.delete('gruposComerciales?id='+item.id );
            this.alertSuccess('El grupo comercial ha sido eliminado.')
            this.clearAndReload();
        }
        catch(error){
            // Error
            Vue.$log.error(error);
            if(error.includes("The DELETE statement conflicted with the REFERENCE constraint")){
              this.alertError('El grupo comercial no puede ser eliminado debido a que está asociada a uno o más canales de venta.');
            } else {
              this.alertError(error)
            }
        }
      }
    },
    async copiarDomicilio(){
      if(this.model.perteneceAId && (this.model.perteneceAId !== "00000000-0000-0000-0000-000000000000")){
        try {
          var result = await http.get('personas/' +this.model.perteneceAId );  

          for(let i = 0; i<result.domicilios.length;i++)
          {
            if(result.domicilios[i].esPrincipal)
            {
              this.model.domicilio = result.domicilios[i];
            }
          }
        } catch (error) {
          // Error        
          this.alertError(error)
        }
      }
      else{
        Vue.$log.debug('won');
        this.alertWarning('Por favor, ingrese una persona y vuelva a intentar.')
      }
    },
    async verCanalesVenta(){
      try{
            Vue.$log.debug(this.model.id);
            var result = await http.get('gruposComerciales/ListarCanalesVenta?grupoComercialId='+this.model.id );
            Vue.$log.debug(result);

            this.listaCanalesVenta = result.list;
            this.dialogCanalesVenta = true;
            
        }
      catch (error) {
          // Error        
          this.alertError(error)
        }
    },
    async updateStatus(){
      this.loading = true
      this.model.status.baja = !this.model.status.baja;

      console.log(JSON.stringify( {status: {entidadId: this.model.id, status: this.model.status}} ))
      try{
          await http.put('gruposComerciales/updatestatus', JSON.stringify( {status: {entidadId: this.model.id, status: this.model.status}} ) );
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
      } 
      catch(error){
        Vue.$log.error(error);
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async agregarCanalVenta(){

    },
    closeDialog: function(){
        Vue.$log.debug('close dialog 2');
        this.dialogCanalesVenta = false;
    }
  } 
}
</script>